var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95703 2.29163V17.7083H11.6654C12.0105 17.7083 12.2904 17.9881 12.2904 18.3333C12.2904 18.6785 12.0105 18.9583 11.6654 18.9583H3.83203C3.21071 18.9583 2.70703 18.4546 2.70703 17.8333V2.16663C2.70703 1.54531 3.21071 1.04163 3.83203 1.04163H13.5416C13.84 1.04163 14.1261 1.16015 14.3371 1.37113L16.9609 3.9949C17.1718 4.20588 17.2904 4.49203 17.2904 4.7904V10.8333C17.2904 11.1785 17.0105 11.4583 16.6654 11.4583C16.3202 11.4583 16.0404 11.1785 16.0404 10.8333V4.84218L13.4898 2.29163H3.95703Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.332 1.04163C13.6772 1.04163 13.957 1.32145 13.957 1.66663V4.37496H16.6654C17.0105 4.37496 17.2904 4.65478 17.2904 4.99996C17.2904 5.34514 17.0105 5.62496 16.6654 5.62496H13.832C13.2107 5.62496 12.707 5.12128 12.707 4.49996V1.66663C12.707 1.32145 12.9869 1.04163 13.332 1.04163Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3901 18.7752C15.6342 19.0193 16.0299 19.0193 16.274 18.7752L18.774 16.2752C19.0181 16.0312 19.0181 15.6354 18.774 15.3914L16.274 12.8914C16.0299 12.6473 15.6342 12.6473 15.3901 12.8914C15.146 13.1354 15.146 13.5312 15.3901 13.7752L16.8231 15.2083H13.332C12.9869 15.2083 12.707 15.4881 12.707 15.8333C12.707 16.1785 12.9869 16.4583 13.332 16.4583H16.8231L15.3901 17.8914C15.146 18.1354 15.146 18.5312 15.3901 18.7752Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.d85a52bdd317f98cf0f1693df1a4f3ae.svg";
export { ForwardRef as ReactComponent };